<template>
    <div class="content">
        <div class="content_img invalidImg"><img v-lazy="$viewImageNew(sku.pictureUrl, 400,400)" alt=""></div>
        <div class="content_right">
            <h3>{{ sku.skuShowName }}</h3>
            <div class="content_right_bottom">
                <div class="content_right_bottom_price color999" v-if="!presaleId"><span>¥ </span>{{ sku.price | NumFormat }}</div>
                <div class="content_right_bottom_price color999" v-else><span>¥ </span>????</div>
                <span><sub>x</sub>{{ sku.quantity }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sku: {
            type: Object,
            default: () => {
                return {}
            }
        },
        presaleId: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    margin: 32px 0;
    &.invalidContent {
        margin-bottom: 48px;
        &:last-child {
            margin-bottom: 0;
        }
        .checked {
            display: flex;
            align-items: center;
            padding-left: 8px;
            span {
                display: inline-block;
                width: 72px;
                height: 34px;
                border-radius: 34px;
                font-size: 24px;
                text-align: center;
                color: #fff;
                background: #aaa;
            }
        }
        .invalidImg {
            margin: 0 24px 0 8px;
        }
        .color999 {
            color: #999;
        }
    }
    &_img {
        width: 184px;
        height: 184px;
        margin-right: 24px;
        position: relative;
        display: flex;
        background: #f2f3f5;
        img {
            display: inline-block;
            align-self: center;
            justify-self: center;
            margin: 0 auto;
            object-fit: cover;
        }
    }
    &_right {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        h3 {
            width: 100%;
            color: #333;
            font-weight: 400;
            line-height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
        }
        &_bottom {
            flex: 1;
            line-height: 48px;
            display: flex;
            justify-content: space-between;
            position: relative;
            &_price {
                color: #ff7a45;
                font-size: 30px;
                span {
                    font-size: 20px;
                }
            }
        }
    }
}
</style>
